import React from 'react';
import { Link } from 'react-router-dom';

const LINKS = [
  { to: '/advogados', label: 'Advogados' },
  { to: '/cidades', label: 'Advogados por cidade' },
  { to: '/categorias', label: 'Áreas do Direito' },
  { to: '/artigos', label: 'Blog' },
  { to: '/match', label: 'Busca Advogado com IA' },
  { to: '/simulador/rescisao', label: 'Simulador de rescisão' },
  { to: '/simulador/aposentadoria', label: 'Simulador de aposentadoria' },
  { to: '/planos', label: 'Planos para escritórios' },
  { to: '/cadastro', label: 'Cadastrar escritório' },
  { to: '/login', label: 'Entrar' },
];

const linkCls = 'block py-2 min-h-[44px] text-[#075a6d] hover:text-[#063f4c] underline underline-offset-[0.18em] decoration-[0.075em]';

export default function Footer() {
  return (
    <div className="aj-wrap mt-10">
      <footer className="bg-white border-t-2 border-[#153e44] py-9 text-[#354c54] text-[15px] leading-[1.8]" data-testid="site-footer">
        <div className="grid grid-cols-1 md:grid-cols-[2fr_1fr] gap-10 md:gap-14">
          <div>
            <Link to="/" className="aj-wordmark inline-block mb-4">Ambito<br />Advogados</Link>
            <p className="m-0">
              Ambito Advogados é a plataforma de escritórios de advocacia do{' '}
              <a href="https://ambitojuridico.com.br/" target="_blank" rel="noopener" className="text-[#075a6d] underline underline-offset-[0.18em]">Âmbito Jurídico</a>.
              Perfis reais, organizados por cidade e área de atuação, para você encontrar o advogado certo.<br />
              Este site respeita o Provimento nº 205/2021 da OAB: não há venda de leads nem intermediação de honorários.<br />
              E-mail: <a href="mailto:contato@ambitoadvogados.com.br" className="text-[#075a6d] underline underline-offset-[0.18em]">contato@ambitoadvogados.com.br</a>
            </p>
            <p className="mt-4 mb-0">© {new Date().getFullYear()} Ambito Advogados. Todos os direitos reservados.</p>
            <a href="#top" className="inline-block mt-3 py-3 min-h-[48px] text-[#075a6d] underline underline-offset-[0.18em]">Voltar ao topo ↑</a>
          </div>
          <nav aria-label="Links do marketplace">
            {LINKS.map(l => <Link key={l.to} to={l.to} className={linkCls}>{l.label}</Link>)}
            <a href="/api/sitemap.xml" className={linkCls}>Sitemap</a>
            <a href="https://ambitojuridico.com.br/" target="_blank" rel="noopener" className={linkCls}>Conteúdos jurídicos no Âmbito Jurídico →</a>
          </nav>
        </div>
      </footer>
    </div>
  );
}
